import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../core/constants/api-routes';
import { UnsupportedApplicationResponse } from '../../../unsupported/models/unsupported-application-response';
import { SubmitUnsupportedApplicationToEwaRequest } from '../../../unsupported/models/submit-to-ewa/submit-unsupported-application-to-ewa-request';

@Injectable({ providedIn: 'root' })
export class UnsupportedApplicationService {
    private readonly unsupportedApi = ApiRouteConstants.UnsupportedApplication;

    constructor(private readonly http: HttpClient) {}

    /**
     * Retrieves the unsupported application.
     * @param applicationId The ID of the unsupported application to fetch.
     * @returns Observable that emits the unsupported application response.
     */
    getUnsupportedApplication(
        applicationId: string,
    ): Observable<UnsupportedApplicationResponse> {
        const url =
            this.unsupportedApi.getRootUrlWithApplicationId(applicationId);
        return this.http.get<UnsupportedApplicationResponse>(url);
    }

    /**
     * Updates the unsupported application (e.g., comments).
     * @param applicationId The ID of the unsupported application to update.
     * @param payload The update payload.
     * @returns Observable that completes when the update is successful.
     */
    updateUnsupportedApplication(
        applicationId: string,
        payload: { comments: string | null },
    ): Observable<void> {
        const url =
            this.unsupportedApi.getRootUrlWithApplicationId(applicationId);
        return this.http.post<void>(url, payload);
    }

    /**
     * Makes request to API to submit an unsupported application to EWA.
     * Once complete, the server updates the application to Express (E) and sets HandoverToEwa = TRUE.
     * @param request Request object containing the application ID and payload.
     * @returns The server response echoing key submission details
     */
    submitUnsupportedApplicationToEwa(
        request: SubmitUnsupportedApplicationToEwaRequest,
    ): Observable<null> {
        const url = this.unsupportedApi.getFullRouteWithApplicationId(
            'submitToEwa',
            request.applicationId,
        );
        return this.http.post<null>(url, request);
    }
}
